import { render, staticRenderFns } from "./IconHolder.vue?vue&type=template&id=b5ea9100&scoped=true&"
import script from "./IconHolder.vue?vue&type=script&lang=js&"
export * from "./IconHolder.vue?vue&type=script&lang=js&"
import style0 from "./IconHolder.vue?vue&type=style&index=0&id=b5ea9100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ea9100",
  null
  
)

export default component.exports